import React from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import AuthActions from '../actions/AuthActions';
import AuthStore from '../stores/AuthStore';
import { withRouter } from 'react-router-dom';

class HeaderComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      authenticated: AuthStore.isAuthenticated()
    }
    this.logout = this.logout.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  logout() {
    AuthActions.logUserOut();
  }

  componentWillMount() {
    AuthStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AuthStore.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      authenticated: AuthStore.isAuthenticated()
    });
  }

  render() {
    return (
      <header>
        <div className="logo"/>
        <Nav>
          { this.state.authenticated ? (
            <NavItem className="logout" onClick={this.logout}>Logout</NavItem>
          ):''}
        </Nav>
      </header>
    );
  }
}

export default withRouter(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/Header.js